import { type PropsWithChildren, useCallback, useState } from 'react';

import { EEthnicity } from '@enums/Ethnicity';
import { EGender } from '@enums/Gender';

import { TaxaFiltracaoGlomerularContext } from './context';

export const TaxaFiltracaoGlomerularProvider = ({
  children,
}: PropsWithChildren) => {
  const [age, setAge] = useState<number>(0);
  const [ethnicity, setEthnicity] = useState<EEthnicity>(EEthnicity.Others);
  const [gender, setGender] = useState<EGender>(EGender.Male);
  const [plasmaCreatinine, setPlasmaCreatinine] = useState<number>(0);
  const [weight, setWeight] = useState<number>(0);

  const handleAge = useCallback((value: number): void => {
    setAge(value);
  }, []);

  const handleEthnicity = useCallback((value: EEthnicity): void => {
    setEthnicity(value);
  }, []);

  const handleGender = useCallback((value: EGender): void => {
    setGender(value);
  }, []);

  const handlePlasmaCreatinine = useCallback((value: number): void => {
    setPlasmaCreatinine(value);
  }, []);

  const handleWeight = useCallback((value: number): void => {
    setWeight(value);
  }, []);

  return (
    <TaxaFiltracaoGlomerularContext.Provider
      value={{
        age,
        ethnicity,
        gender,
        plasmaCreatinine,
        setAge: handleAge,
        setEthnicity: handleEthnicity,
        setGender: handleGender,
        setPlasmaCreatinine: handlePlasmaCreatinine,
        setWeight: handleWeight,
        weight,
      }}>
      {children}
    </TaxaFiltracaoGlomerularContext.Provider>
  );
};
